import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { APIS } from "../../../../utils/APIS";
import { GET, POST, PUT, DELETE } from "../../../../utils/Methods";
import { IDS } from "../../../../utils/IDS";

//Contact us - Get All (Read)
export const GetAll = createAsyncThunk(
  "contactuss/farmer-dealer/get-all",
  async (filter, { rejectWithValue }) => {
    try {
      const res = await GET(
        `${APIS.Contactuss.Farmer_Dealer}?name=${filter?.name || ""}
        &enquiry_type=${filter?.enquiry_type || ""}
        &page=${
          filter?.page || IDS.PAGE
        }&per_page=${filter?.per_page || IDS.PERPAGE}`,
      );
      return res;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  },
);

//Contact us - Get (Read)
export const GetSingle = createAsyncThunk(
  "contactuss/farmer-dealer/get",
  async (id, { rejectWithValue }) => {
    try {
      const res = await GET(`${APIS.Contactuss.Farmer_Dealer}/${id}`);
      return res;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  },
);

//Contact us - Create (Add)
export const Create = createAsyncThunk(
  "contactuss/farmer-dealer/create",
  async (data, { rejectWithValue }) => {
    try {
      const res = await POST(APIS.Contactuss.Farmer_Dealer, data);
      return res; // The new object
    } catch (error) {
      return rejectWithValue(error.message);
    }
  },
);

//Contact us - Update
export const Update = createAsyncThunk(
  "contactuss/farmer-dealer/update",
  async ({ id, data }, { rejectWithValue }) => {
    try {
      const res = await PUT(`${APIS.Contactuss.Farmer_Dealer}/${id}`, data);
      return res;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  },
);

//Contact us - Delete
export const Delete = createAsyncThunk(
  "contactuss/farmer-dealer/delete",
  async (id, { rejectWithValue }) => {
    try {
      const data = await DELETE(`${APIS.Contactuss.Farmer_Dealer}/${id}`);
      return id; // Return the id of the deleted bill
    } catch (error) {
      return rejectWithValue(error.message);
    }
  },
);

//Contact us - Status
export const StatusFarmerDealer = createAsyncThunk(
  "contactuss/farmer-dealer/status",
  async (id, { rejectWithValue }) => {
    try {
      const res = await POST(`${APIS.Contactuss.Farmer_Dealer}/${id}`);
      return res;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  },
);

export const Slice = createSlice({
  name: "farmerdealer",
  initialState: {
    data: [],
    current_page: IDS.PAGE,
    total_pages: IDS.TOTALPAGES,
    per_page: IDS.PERPAGE,
    total: IDS.TOTAL,
    status: IDS.SLICESTATUS.Idle,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      // Handling all actions for GetSingle, Create, Update, Delete
      .addCase(GetAll.pending, (state) => {
        state.status = IDS.SLICESTATUS.Loading;
      })
      .addCase(GetAll.fulfilled, (state, action) => {
        state.status = IDS.SLICESTATUS.Succeeded;
        state.data = action.payload?.data?.data || [];
        state.current_page = action.payload?.data?.current_page || IDS.PAGE;
        state.total_pages = action.payload?.data?.total_pages || IDS.TOTALPAGES;
        state.per_page = action.payload?.data?.per_page || IDS.PERPAGE;
        state.total = action.payload?.data?.total || IDS.TOTAL;
      })
      .addCase(GetAll.rejected, (state, action) => {
        state.status = IDS.SLICESTATUS.Failed;
        state.error = action.payload;
      })

      .addCase(GetSingle.pending, (state) => {
        state.status = IDS.SLICESTATUS.Loading;
      })
      .addCase(GetSingle.fulfilled, (state, action) => {
        state.status = IDS.SLICESTATUS.Succeeded;
      })
      .addCase(GetSingle.rejected, (state, action) => {
        state.status = IDS.SLICESTATUS.Failed;
        state.error = action.payload;
      })

      .addCase(Delete.pending, (state) => {
        state.status = IDS.SLICESTATUS.Loading;
      })
      .addCase(Delete.fulfilled, (state, action) => {
        state.status = IDS.SLICESTATUS.Succeeded;
        // state.data = action.payload;
        state.data = state.data.filter(
          (contactus) => contactus.id !== action.payload,
        ); // Remove with the deleted id
      })
      .addCase(Delete.rejected, (state, action) => {
        state.status = IDS.SLICESTATUS.Failed;
        state.error = action.payload;
      })

      //
      .addCase(StatusFarmerDealer.pending, (state) => {
        state.status = IDS.SLICESTATUS.Loading;
      })
      .addCase(StatusFarmerDealer.fulfilled, (state, action) => {
        state.status = IDS.SLICESTATUS.Succeeded;
        // state.data = action.payload;
        state.data = state.data.filter(
          (contactus) => contactus.id !== action.payload.id,
        ); // Remove the with the deleted id
      })
      .addCase(StatusFarmerDealer.rejected, (state, action) => {
        state.status = IDS.SLICESTATUS.Failed;
        state.error = action.payload;
      });
  },
});

// Export actions (if needed in components)
export const {} = Slice.actions;

export default Slice.reducer;
